
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class WindowEventListener extends Vue {
  @Prop({ required: true, type: String }) private event!: string;
  @Prop({ required: false, type: Object }) private eventOptions?: object;

  public mounted() {
    window.addEventListener(this.event, this.onTrigger, this.eventOptions);
  }

  public destroyed() {
    // if we have trouble with removing wrong/too many/too few eventlistners,
    // consider using AbortController/AbortSignal
    window.removeEventListener(this.event, this.onTrigger, this.eventOptions);
  }

  private onTrigger(...args: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
    this.$emit('trigger', ...args);
  }

  public render() {
    return null;
  }
}
